import { type UseQueryResult, useQuery } from 'react-query';

import {
  PsuAwardService,
  RsuAwardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto,
  type Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto,
  type Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto,
  OptionAwardService,
} from '@wealthlane/api-services/wealthlane-award-service';
import { withExcludeDecimalFields } from '../decorators/withDecimalConversion';

const useGetAllAwardDetailsById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string,
  awardType?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto
  | Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto
  | Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto
  | undefined,
  unknown
> => {
  const allAwardDetails = useQuery(['allAwardDetails', id], async () => {
    if (id && awardType === 'RSU') {
      return await handleRequest(
        RsuAwardService.getApiAwardApiAppRSUAwardRSUAwardDetailByRSuVestingDateId(id)
      );
    }
    if (id && awardType === 'PSU') {
      return await handleRequest(
        PsuAwardService.getApiAwardApiAppPSUAwardPSUAwardDetailByPSuVestingDateId(id)
      );
    }
    if (id && (awardType === 'ESOP' || awardType === 'ISO' || awardType === 'Options')) {
      return await handleRequest(
        OptionAwardService.getApiAwardApiAppOptionAwardOptionAwardOverview(id)
      );
    }
  });

  return allAwardDetails;
};

export default withExcludeDecimalFields(['fairValue'])(useGetAllAwardDetailsById);
